<template>
  <div class="maincont child" id="news_mod">
    <div class="ef--inner">
      <h2>お知らせ更新</h2>
      <!--//<h2>アカウント変更</h2>//-->
      <div method="post" action class="form">
        <div id="news_form">
          <ul>
            <li>
              <label for="content" class>日時</label>
              <datetime
                style="display:inline-block;"
                input-style="border: 2px solid rgb(92, 161, 214);border-radius: 2px;"
                v-model="date"
                format="yyyy/MM/dd HH:mm"
                type="datetime"
              ></datetime>
            </li>

            <li id="lebel">
              <label for="status">お知らせレベル</label>
              <label for="normal">
                <input
                  type="radio"
                  name="status"
                  class="radio"
                  id="normal"
                  v-model="param.level"
                  v-bind:value="1"
                />
                <span class="radio-icon"></span>
                通知
                <span class="normal">■</span>
              </label>
              <label for="warning">
                <input
                  type="radio"
                  name="status"
                  class="radio"
                  id="warning"
                  v-model="param.level"
                  v-bind:value="2"
                />
                <span class="radio-icon"></span>
                注意
                <span class="warning">■</span>
              </label>
              <label for="alert">
                <input
                  type="radio"
                  name="status"
                  class="radio"
                  id="alert"
                  v-model="param.level"
                  v-bind:value="3"
                />
                <span class="radio-icon"></span>
                警報
                <span class="alert">■</span>
              </label>
            </li>

            <li>
              <input
                type="button"
                id="clear"
                class="clear"
                value="選択クリア"
                @click="onClear"
              />
            </li>

            <li>
              <label for="content" class="textline_label">お知らせ</label>
              <div style="display:inline-block">
                <textarea
                  id="content"
                  class="textline"
                  v-model="param.message"
                  v-validate="'max:100'"
                  name="param.message"
                  data-vv-as="お知らせ"
                ></textarea>
                <div class="err_message">
                  {{ errors.first("param.message") }}
                </div>
              </div>
            </li>
          </ul>

          <div id="submit_area">
            <input
              type="button"
              id="submit"
              class="submit"
              value="登　録"
              @click="onSubmit"
            />
            <input
              type="button"
              id="cancel"
              class="cancel"
              value="キャンセル"
              @click="$router.go(-1)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
import moment from "moment";
export default {
  name: "notice-edit",
  data: function() {
    return {
      param: {
        level: 1,
        message: "",
        datetime: ""
      }
    };
  },
  computed: {
    date: {
      get: function() {
        return moment(this.param.datetime, "YYYY/MM/DD HH:mm:ss").format();
      },
      set: function(newVal) {
        this.param.datetime = moment(newVal).format("YYYY/MM/DD HH:mm:00");
      }
    }
  },
  mounted: function() {
    this.$axios
      .get(`/srv/api/notice/`, {
        withCredentials: true
      })
      .then(response => {
        console.log(response.data);
        this.param = response.data;
      })
      .catch(error => {
        console.log(error);
      });
  },
  methods: {
    onClear: function() {
      this.param = {
        level: null,
        message: null,
        datetime: null
      };
    },
    onSubmit: function() {
      this.$validator.validateAll().then(result => {
        console.log(result);

        if (result) {
          this.$axios
            .put(`/srv/api/notice/`, this.param, {
              withCredentials: true
            })
            .then(response => {
              console.log(response.data);
              if (response.data.status == "success") {
                this.$router.go(-1);
              } else {
                console.log(error);
                alert("登録できませんでした");
              }
            })
            .catch(error => {
              console.log(error);
              alert("登録できませんでした");
            });
        }
      });
    }
  }
};
</script>

